export default function LegalFooter({ styles }) {
  const isMobile = window.innerWidth <= 600;

  return (
    <div
      style={{
        ...f.wrapper,
        marginTop: isMobile ? 40 : 80,
        paddingTop: isMobile ? 20 : 40,
      }}
    >
      {/* Brand / Header */}
      <div
        style={{
          ...styles.sectionTitle,
          fontSize: isMobile ? 20 : 26,
        }}
      >
        SpeedDigits Trainer
      </div>

      {/* Links / Sub-header */}
      <div style={f.links}>
        <span
          style={{
            ...styles.subSectionTitle,
            fontSize: isMobile ? 13 : undefined,
          }}
        >
          Privacy Policy
        </span>

        <span style={f.dot}>•</span>
        <span
          style={{
            ...styles.subSectionTitle,
            fontSize: isMobile ? 13 : undefined,
          }}
        >
          Terms of Service
        </span>

        <span style={f.dot}>•</span>
        <span
          style={{
            ...styles.subSectionTitle,
            fontSize: isMobile ? 13 : undefined,
          }}
        >
          Refund Policy
        </span>
      </div>

      {/* Text */}
      <p
        style={{
          ...styles.text,
          fontSize: isMobile ? 13 : 16,
          marginBottom: 6,
        }}
      >
        © 2025 SpeedDigits Trainer®. All rights reserved.
      </p>

      <p
        style={{
          ...styles.text,
          fontSize: isMobile ? 13 : 16,
        }}
      >
        Made with <span style={{ color: "#ec4899" }}>♥</span> in India
      </p>
    </div>
  );
}

const f = {
  wrapper: {
    marginTop: 80,
    paddingTop: 40,
    textAlign: "center",
    borderTop: "2px dotted rgba(147,51,234,0.45)",
  },

  links: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 12,
    margin: "18px 0 22px",
    whiteSpace: "normal",
    flexWrap: "wrap",
  },

  dot: {
    fontSize: 20,
    opacity: 0.6,
  },
};
